export const mapChallengeStatusToIcon = {
  PENDING: 'timer',
  ACCEPTED: 'check_circle_outline',
  FINISHED: 'done_all',
  EXPIRED: 'timer_off',
  REJECTED: 'remove_circle_outline'
};
